import { useSelector } from "react-redux";
import { currentStep, Media } from "../../../store";
import { useCallback } from "react";
import { Confirmation, Review, Select, Upload } from "./steps";

export const Body = () => {

  const step = useSelector(currentStep);

  const getSection = useCallback(() => {
    switch (step) {
      case Media.SELECT:
        return <Select />;
      case Media.REVIEW:
        return <Review />;
      case Media.UPLOAD:
        return <Upload />;
      case Media.CONFIRMATION:
        return <Confirmation />;
      default:
        <h1>404</h1>
    }
  }, [step])

  return (
    <div className="body" data-step={step} key={step}>
      { getSection() }
    </div>
  );
}